import dayjs from 'dayjs';
import app from '../app';

/**
 * The `fullTime` helper displays a formatted time string wrapped in a <time>
 * tag.
 */
export default function fullTime(time) {
  const d = dayjs(time);
  const datetime = d.format();
  const full = app.translator.formatDateTime(d, 'core.lib.datetime_formats.fullTime');
  return m("time", {
    pubdate: true,
    datetime: datetime
  }, full);
}
flarum.reg.add('core', 'common/helpers/fullTime', fullTime);